import { coreUsersByIdPasswordPatchAsyncSlice } from './patch';

export const { requestPatchCoreUsersByIdPassword, resetPatchCoreUsersByIdPassword } =
	coreUsersByIdPasswordPatchAsyncSlice.asyncActionCreators;
